import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

export function TextCell(props) {
  return (
    <div className={props.className}>
      <ReactMarkdown rehypePlugins={[rehypeRaw]}>{props.text.replace("\\_", "_")}</ReactMarkdown>
    </div>
  );
}

TextCell.propTypes = {
  /**
   * Text to be displayed on the cell
   */
  text: PropTypes.string,
  /**
   * className to be set on the cell
   */
  className: PropTypes.string,
};
